export default __webpack_public_path__ + "static/media/LouisReed.100c7ee6.jpeg";